import { Column, HeaderFilter } from "devextreme-react/data-grid";
import { PagedList } from "../../../../core/api/pagedList";
import WatchLogApi from "../../api/watchLogApi";
import { InstructionalVideoWatchLogDto } from "../../model/watchLogDto";
import { t } from "i18next";
import DateTimeLocal from "../../../../core/components/typography/DateTimeLocal";
import { useWatchStates } from "../../hook/useWatchStates";
import { GenericDataGrid } from "../../../../core/components";

interface WatchLogListProps {

}

export default function WatchLogList(props: WatchLogListProps) {
    const { watchStatesLookup } = useWatchStates()

    const fetchData = async (odataQueryParameters?: string): Promise<PagedList<InstructionalVideoWatchLogDto>> => {
        const response = await WatchLogApi.getList(odataQueryParameters)
        return response
    }

    return <GenericDataGrid
        id={"WatchLogList"}
        className="card m-05"
        rowKey={"idInstructionalVideoWatchLog"}
        fetchData={fetchData}
        columnAutoWidth={true}
        columnHidingEnabled={false}>
        <HeaderFilter visible={false} />
        <Column
            dataField="instructionalVideoTitle"
            caption={t("Video")}
            fixed
            fixedPosition="left"
            allowSorting={false} />
        <Column
            dataField="userDisplayName"
            caption={t("User")}
            allowSorting={false} />
        <Column
            dataField="state"
            caption={t("State")}
            minWidth={100}
            allowSorting={false}
            lookup={watchStatesLookup} />
        <Column
            dataField="watchedDuration"
            caption={t("Watched Duration")}
            allowSorting={false}
            width={200} />
        <Column
            dataField="watchStartedUtc"
            caption={t("Started At")}
            allowSorting={false}
            width={200}
            cellRender={e => <DateTimeLocal dateTimeUtc={e.data.watchStartedUtc} />} />
        <Column
            dataField="watchFinishedUtc"
            allowSorting={false}
            caption={t("Finished At")}
            width={200}
            cellRender={e => <DateTimeLocal dateTimeUtc={e.data.watchFinishedUtc} />} />
    </GenericDataGrid>
}
